export default "/images/vendor/flag-icon-css/flags/4x3/ke.svg?74aaf58557811d8e79ab93e6e0a2d3f5";